export default "__VITE_ASSET__8uQm5bG0__"